// Add your custom JS here.

// Mobile dropdown toggle functionality
document.addEventListener('DOMContentLoaded', function() {
	function initMobileDropdowns() {
		const dropdownToggles = document.querySelectorAll('.header-nav .dropdown > a.dropdown-toggle');
		const dropdownMenus = document.querySelectorAll('.header-nav .dropdown .dropdown-menu');

		// Only apply to mobile screens
		if (window.innerWidth <= 991) {
			dropdownToggles.forEach(function(toggle) {
				// Store original data-bs-toggle value and remove it to disable Bootstrap dropdown
				if (!toggle.hasAttribute('data-original-bs-toggle')) {
					const originalToggle = toggle.getAttribute('data-bs-toggle');
					if (originalToggle) {
						toggle.setAttribute('data-original-bs-toggle', originalToggle);
						toggle.removeAttribute('data-bs-toggle');
					}
				}

				// Remove any existing event listeners by cloning
				const newToggle = toggle.cloneNode(true);
				toggle.parentNode.replaceChild(newToggle, toggle);

				newToggle.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					const parentDropdown = this.closest('.dropdown');
					const dropdownMenu = parentDropdown.querySelector('.dropdown-menu');

					// Remove any inline transform styles added by Bootstrap/Popper
					dropdownMenu.style.transform = '';
					dropdownMenu.style.position = '';
					dropdownMenu.style.inset = '';

					const isVisible = dropdownMenu.style.display === 'block';

					// Close all other dropdowns
					document.querySelectorAll('.header-nav .dropdown .dropdown-menu').forEach(function(menu) {
						menu.style.display = 'none';
						menu.style.transform = '';
						menu.style.position = '';
						menu.style.inset = '';
					});

					// Toggle current dropdown by setting display property
					if (!isVisible) {
						dropdownMenu.style.display = 'block';
					} else {
						dropdownMenu.style.display = 'none';
					}
				});
			});

			// Remove transform from all dropdown menus on mobile
			dropdownMenus.forEach(function(menu) {
				menu.style.transform = '';
				menu.style.position = '';
				menu.style.inset = '';
			});
		} else {
			// Restore Bootstrap dropdown on desktop
			dropdownToggles.forEach(function(toggle) {
				const originalToggle = toggle.getAttribute('data-original-bs-toggle');
				if (originalToggle) {
					toggle.setAttribute('data-bs-toggle', originalToggle);
					toggle.removeAttribute('data-original-bs-toggle');
				}
			});

			// Reset display and transform styles on desktop
			dropdownMenus.forEach(function(menu) {
				menu.style.display = '';
				menu.style.transform = '';
				menu.style.position = '';
				menu.style.inset = '';
			});
		}
	}

	// Initialize on page load
	initMobileDropdowns();

	// Reinitialize on window resize
	let resizeTimer;
	window.addEventListener('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			initMobileDropdowns();
		}, 250);
	});

	// Close dropdowns when clicking outside
	document.addEventListener('click', function(e) {
		if (window.innerWidth <= 991 && !e.target.closest('.dropdown')) {
			document.querySelectorAll('.header-nav .dropdown .dropdown-menu').forEach(function(menu) {
				menu.style.display = 'none';
				menu.style.transform = '';
				menu.style.position = '';
				menu.style.inset = '';
			});
		}
	});
});